export const API_URL = "https://grafapp.ru";

export const DaDataToken = "ee8a28a88b85036576b11e5ae5dbbceb4077a3ed";

export const passType = [
  { id: "one-time", name: "Разовый пропуск (авто)" },
  { id: "tech_personal", name: "Пропуск на технический персонал без авто" },
  { id: "tech", name: "Многоразовый пропуск" },
  { id: "permanent", name: "Постоянный пропуск на авто (владелец)" }
];

export const carType = [
  { id: "passenger", name: "Легковой" },
  { id: "1.5", name: "Гр.тр. до 1,5 т." },
  { id: "3.5", name: "Гр.тр. до 3,5 т." },
  { id: "5", name: "Гр.тр. до 5 т." },
  { id: "heavy_lorry", name: "Фура/Спецтехника" }
];

export const statusType = [
  { id: "new", name: "Новая" },
  { id: "manager", name: "Менеджер назначен" },
  { id: "in_work", name: "В работе" },
  { id: "done", name: "Выполнен" },
  { id: "cancelled", name: "Отменён" }
];

export const countyType = [
  { id: "forest", name: "Графский Лес" },
  { id: "pond", name: "Графские Пруды" }
];

export const passStatusType = [
  { id: "false", name: "Активен" },
  { id: "true", name: "Не активен" }
];

export const requestType = [
  { id: "application", name: "Заявка" },
  { id: "consierge_service", name: "Консьерж-сервис" },
  { id: "event_order", name: "Бронирование" }
];

export const countItemsOmPage = [10, 20, 30, 50];

export const cameraList = [
  { link: "https://rtsp.me/embed/4tRbfEb2/", name: "Взлетка 1 (ул.Парковая)" },
  { link: "https://rtsp.me/embed/e6Ry4Y8d/", name: "Взлетка 2 (ул.Парковая)" },
  { link: "https://rtsp.me/embed/H5FbZKGe/", name: "Лес 13 (ул.Ольховая)" },
  { link: "https://rtsp.me/embed/bQ7R3dzr/", name: "Лес 6 (ул.Ольховая)" },
  {
    link: "https://rtsp.me/embed/E9Fitzt5/",
    name: "Спорт. площадка (1-й парковый проезд)"
  },
  {
    link: "https://rtsp.me/embed/F6Z3eRGb/",
    name: "Пруд (ул.Бульварное кольцо)"
  },
  { link: "https://rtsp.me/embed/nSydbz6N/", name: "Лес 22 (ул.Ольховая)" },
  {
    link: "https://rtsp.me/embed/9dYQrkHR/",
    name: "Арка КПП (на ул.Кленовая)"
  },
  { link: "https://rtsp.me/embed/t7nBi6yd/", name: "На арку (на ул.Парковая)" },
  {
    link: "https://rtsp.me/embed/4eZfT9Gs/",
    name: "3Га (ул.Бульварное кольцо)"
  },
  { link: "https://rtsp.me/embed/5Rs5tHNB/", name: "ОТЦ (ул.Парковая)" }
];

export const userRole = [
  { id: "member", name: "Член клуба" },
  { id: "non_member", name: "Не член клуба" },
  { id: "resident", name: "Житель" },
  { id: "manager", name: "Управляющий дома" },
  { id: "debtor", name: "Должник" }
];

export const meterType = [
  /* { id: 'gase', name: 'Газ' }, */
  { id: "cold_water", name: "Холодная вода" },
  /* { id: 'hot_water', name: 'Горячая вода' }, */
  { id: "electricity", name: "Электричество" }
  /* { id: 'heating', name: 'Отопление' }, */
];

export const deliveryType = [
  { id: "delivery", name: "Доставка" },
  { id: "pickup", name: "Самовывоз" }
];

export const counterStatus = [
  { id: "work", name: "Активен" },
  { id: "change", name: "Замена" },
  { id: "off", name: "Отключен" }
];

export const userStatus = [
  { id: "true", name: "Одобрен" },
  { id: "false", name: "Отклонен/Модерация" }
];
